import { saveState, getSavedState } from '@utils/local-storage'

/* state -------------------------------------------------------------------- */
export const state = {
  token: getSavedState('auth.token'),
  currentUser: getSavedState('auth.currentUser'),
}

/* getters ------------------------------------------------------------------ */
export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  token() {
    return state.token
  },
  currentUser() {
    return state.currentUser
  },
}

/* mutations ---------------------------------------------------------------- */
export const mutations = {
  SET_CURRENT_TOKEN(state, value) {
    state.token = value
    saveState('auth.token', value)
  },
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
  },
}

/* actions ------------------------------------------------------------------ */
export const actions = {
  init({ state, dispatch }) {
    // dispatch('validateUser')
  },

  validateUser({ commit, state, dispatch }) {
    if (!state.token) return Promise.resolve(null)

    return state.token
  },

  logOut({ dispatch }) {
    dispatch('setCurrentToken', null)
    dispatch('setCurrentUser', null)
    dispatch('verify/setEventData', null, { root: true })
  },

  setCurrentToken({ commit, dispatch, state }, val) {
    commit('SET_CURRENT_TOKEN', val)
  },

  setCurrentUser({ commit, dispatch, state }, val) {
    commit('SET_CURRENT_USER', val)
  },
}
